import * as React from 'react';

// @ts-ignore
import DeviceActions from 'actions/DeviceActions';
import Link from 'components/Link';
import ToastActions from 'actions/ToastActions';

/* Component to resend a confirmation text:
 *
 * if (user.getUnconfirmedSMS()) {
 *  var resent = <ResendConfirmationSMS>Click me!</ResendConfirmationSMS>;
 * }
 *
 */

type Props = {
  sms: {
    endpoint: string;
    id: number;
  };
  children?: React.ReactNode;
  onShowDialog?: () => void;
};

class ResendConfirmationSMS extends React.Component<Props> {
  resendConfirmation = () => {
    const { sms } = this.props;

    if (sms?.endpoint) {
      DeviceActions.outboundVerify(sms.endpoint)
        .then(
          () => {
            if (this.props.onShowDialog) {
              this.props.onShowDialog();
            }
            ToastActions.showSuccessToast(`Sent confirmation code`);
          },
          () => ToastActions.showErrorToast('Error sending the code')
        )
        .catch((err: any) => {
          console.error(err.toString());
          ToastActions.showDefaultErrorToast();
        });
    } else {
      ToastActions.showDefaultErrorToast();
    }
  };

  render() {
    return (
      <Link
        data-test="resend-confirmation-sms-link"
        onClick={this.resendConfirmation}
        {...this.props}>
        {this.props.children}
      </Link>
    );
  }
}

export default ResendConfirmationSMS;
